export default "__VITE_ASSET__Bn0Qrmf3__"